import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import dayjs from "dayjs";
import { FormControl } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import "./expenseManagementStyle.css";
import CustomAutoCompleteDropdown from "../../../../components/custom_auto_complete_dropdown/CustomAutoCompleteDropdown";
import CustomYearPicker from "../../../../components/custom_year_picker/CustomYearPicker";
import { get_expense_head } from "../../../../api/expenseHeadApis";
import {
  resetExpenseFilter,
  setExpenseFilter,
} from "../../../../slices/expenseFilterSlice";

function ExpenseManagementFilter({ handlePageChange, handleItemsPerPageChange }) {
  const dispatch = useDispatch();
  const globalFilter = useSelector((state) => state.expenseFilter);

  const [expenseHeadOptions, setExpenseHeadOptions] = useState([]);

  useEffect(() => {
    fetchExpenseHeadList();
  }, []);

  const fetchExpenseHeadList = async () => {
    try {
      const response = await get_expense_head();
      const data = response.data?.data?.data || [];
      const options = data.map((item) => ({
        label: item.ExpenseName,
        value: item.expense_head_id,
      }));
      setExpenseHeadOptions(options);
    } catch (error) {
      console.error("Error fetching expense heads:", error);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      expense_head_id: globalFilter.expense_head_id || "",
      month_year: globalFilter.month_year
        ? dayjs(globalFilter.month_year, "YYYY-MM")
        : dayjs(),
    },
    onSubmit: (values) => {
      const payload = {
        expense_head_id: values.expense_head_id || "",
        month_year: values.month_year
          ? dayjs(values.month_year).format("YYYY-MM")
          : "",
      };
      dispatch(setExpenseFilter(payload));
    },
  });

  const resetFilter = () => {
    formik.resetForm();
    dispatch(resetExpenseFilter());
    handlePageChange(1)
    handleItemsPerPageChange(25)
  };

  return (
    <div className="expense-filter">
      <form
        id="expense-filter-form"
        className="expense-filter__form"
        onSubmit={formik.handleSubmit}
      >
        <div className="expense-filter__controls">
          {/* Expense Head Filter */}
          <div className="expense-filter__field">
            <CustomAutoCompleteDropdown
              name="expense_head_id"
              placeholder="Select an expense head"
              options={expenseHeadOptions}
              onChange={(event, newValue) =>
                formik.setFieldValue(
                  "expense_head_id",
                  newValue ? newValue.value : ""
                )
              }
              onBlur={formik.handleBlur}
              value={
                expenseHeadOptions.find(
                  (option) => option.value === formik.values.expense_head_id
                ) || null
              }
            />
          </div>

          {/* Month-Year Picker */}
          <div className="expense-filter__field">
            <FormControl fullWidth>
              <CustomYearPicker
                name="month_year"
                views={["year", "month"]}
                value={formik.values.month_year}
                onChange={(date) => formik.setFieldValue("month_year", date)}
                onBlur={formik.handleBlur}
                maxDate={dayjs().endOf("year")}
              />
            </FormControl>
          </div>

          {/* Actions */}
          <div className="expense-filter__actions">
            <button
              type="button"
              className="expense-filter__action_reset"
              onClick={resetFilter}
            >
              Reset
            </button>
            <button
              type="submit"
              className="expense-filter__action_search"
              form="expense-filter-form"
            >
              Search
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default ExpenseManagementFilter;
